import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import axios from 'axios';
import qs from 'qs';
import { useAtom } from "jotai";
import PassoverMenuDisclaimer from './PassoverMenuDisclaimer';
import OrderList from './OrderList';
import ErrorMessageList from './ErrorMessageList';
import messageMap from './i18n/messageMap.json';
import { fireGoogleAnalyticsTag } from '../analytics/googleAnalytics';
import { customerAtom, orderedMenuItemsAtom, totalPriceWithTaxAtom } from "./atoms";

const ConfirmationPage = () => {
    const [processingOrder, setProcessingOrder] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [customer, setCustomer] = useAtom(customerAtom);
    const [orderedItems] = useAtom(orderedMenuItemsAtom);
    const [orderTotal] = useAtom(totalPriceWithTaxAtom);
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);

        fireGoogleAnalyticsTag({
            category: 'Passover Menu',
            action: 'Confirmation Page View',
            addDevice: true
        });
    }, []);

    const placeOrder = () => {
        setProcessingOrder(true);

        const orderData = {
            orderedItems,
            orderTotal,
            name,
            phoneNumber,
            emailAddress,
        };

        axios.post('/passover-menu/api/submit', qs.stringify(orderData))
            .then(({ data }) => {
                const { error, confirmationNumber, emailError } = data;
                if (error) {
                    fireGoogleAnalyticsTag({
                        category: 'Passover Menu',
                        action: 'Order submission failure',
                        addDevice: true
                    });

                    setErrorMessages([data]);
                    setProcessingOrder(false);
                } else {
                    if (confirmationNumber) {
                        setCustomer((prevCustomer) => ({ ...prevCustomer, confirmationNumber }));
                    }
                    if (emailError) {
                        // if there was an email error,
                        // remove customers email so we don't show message
                        // "we sent you an email..."
                        setCustomer((prevCustomer) => ({ ...prevCustomer, email: undefined }));
                    }
                    navigate('/success');
                }
            })
            .catch((error) => {
                console.error("### Error submitting passover menu order: ", error);
                fireGoogleAnalyticsTag({
                    category: 'Passover Menu',
                    action: 'Order submission failure',
                    addDevice: true
                });

                setErrorMessages([
                    {
                        msg: messageMap['submitFailure']
                    }
                ]);
                setProcessingOrder(false);
            });
    }

    const { name, emailAddress, phoneNumber } = customer;
    return (
        <div id="confirmation" className="passover-menu-page">
            <h2 className="sub-title">Confirm Your Order</h2>
            <div className="order-information-section">
                <p className="order-info"><span className="field-name">Name</span>: {name}</p>
                <p className="order-info"><span className="field-name">Phone Number</span>: {phoneNumber}</p>
                {(emailAddress.length > 0) ? <p className="order-info"><span className="field-name">Email</span>: {emailAddress}</p> : undefined}
            </div>
            <OrderList />
            <ErrorMessageList messages={errorMessages}/>
            <div className="button-disclaimer-section">
                <PassoverMenuDisclaimer
                    hideTitle={true}
                    hidePriceMinimumNotice={true}
                    hideSederNotice={true}
                    hideOrderInfoDisclaimer={true}
                />
                <div className="buttons">
                    <div className={`form-submit-button-holder ${(processingOrder) ? 'disabled' : ''}`}>
                        <button 
                            className="primary form-submit-button"
                            onClick={placeOrder}
                            disabled={processingOrder}
                            >
                            {`${(processingOrder) ? "processing..." : "place order"}`}
                        </button>
                        <div className="form-submit-button-spinner fa fa-spinner fa-spin fa-2x"></div>
                    </div>
                    <Link
                        to={'/'}
                        className="button back-button">
                        <i className="back-arrow-icon fa fa-long-arrow-left" aria-hidden="true"></i>
                        Go Back
                    </Link>
                </div>
            </div>
        </div>
    )

}

export default ConfirmationPage;
